import { use_slice_generation, use_slice_ui } from '@/hooks/store/use_slices';
import { UTILS__generation } from '@/utils/UTILS__generation';
import { DTO__generation_tool_grid2d_view } from '@shared/dto/generation/DTO__generation_tool_grid2d_view';
import { useState } from 'react';
import { G_LIST_ITEM__generation_tools_view_info } from './G_LIST_ITEM__generation_tools_view_info';

interface PROPS {
  tool_view: DTO__generation_tool_grid2d_view;
}

export function G_LIST_ITEM__generation_tools_view({ tool_view }: PROPS) {
  /*
   *
   */

  const { generation_current } = use_slice_generation(['generation_current']);
  const { g_general__ui_disabled } = use_slice_ui(['g_general__ui_disabled']);

  /*
   *
   */

  const is_current = generation_current.tool.grid2d_view_current_name == tool_view.name;
  const [is_hovered, set_is_hovered] = useState(false);

  /*
   *
   */

  async function onClick() {
    if (g_general__ui_disabled) return;
    if (is_current) return;

    let tool_new = generation_current.tool.clone();
    tool_new.view__set_current(tool_view.name);

    await UTILS__generation.update_tool(tool_new);
  }
  /*
   *
   */

  function render_icon() {
    let text = is_current ? '•' : '';

    return <span className="w-2">{text}</span>;
  }
  /*
   *
   */

  return (
    <div
      {...{ onClick }}
      onMouseEnter={() => set_is_hovered(true)}
      onMouseLeave={() => set_is_hovered(false)}
      className={`
        flex flex-col
        pl-2.5 py-0.5
        cursor-pointer
        rounded-sm
      ${is_current || is_hovered ? 'bg-component-item-selected ' : ''}
      `}
    >
      <div
        className={`flex gap-0.5 text-xs 
        text-component-item-foreground`}
      >
        {render_icon()}
        {tool_view.name}
      </div>
      <G_LIST_ITEM__generation_tools_view_info {...{ view: tool_view }} />
    </div>
  );
}
